import { useContext } from 'react';

import { TimeseriesColorPaletteContext } from '../context/TimeseriesColorPalette.context.js';

export const useColorPalette = () => useContext(TimeseriesColorPaletteContext);
